export default __webpack_public_path__ + "static/media/unusualTransaction-enable.715230a3.svg";